<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-md-3.col-lg-2
        b-input-group(size="sm")
          b-input-group-text(slot="prepend")
            span {{ $t("ui.month") }}
          b-form-select(:options="monthOpt" v-model="selectedMonth" size="sm" @change="getListing")
      .form-group.col-md-5.col-lg-5
        b-input-group(size="sm")
          b-input-group-text(slot="prepend")
            span {{ $tc("ui.banks", 1) }}
          BankAccountList(
            ref="bank"
            size="sm"
            required
            type="array"
            v-model="bank"
            :disabled="loading"
            filterBankAccStatus=false
            :operatorID="operatorID"
            @input="getListing"
          )
      .form-group.col-md-12.col-lg-12.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-search"
          :text="$t('ui.search')"
          type="button"
          @click="getListing()"
          variant="primary"
          size="sm"
        ).mr-2
        jsonToExcel(v-if="statementList.length > 0" mode="BankStatement" tbl="tblList" :date="dateRange" btnTxt="export_one").mr-2
        jsonToExcelFull(v-if="statementListFull.length > 0" mode="BankStatement" tbl="tblListFull" :date="dateRange" btnTxt="export_all" type="0" :loading2="loading2").mr-2
        bankStatementExport(v-if="statementList.length > 0" :tbl="statementList" :totalTbl="grandTotalList" tblId="tblList")
        bankStatementExportFull(v-if="statementListFull.length > 0" :tbl="statementListFull" :totalTbl="grandTotalList" tblId="tblListFull")

  .card-body
    .row
      .col-10.mb-1
        b-pagination.float-left(
          size="sm"
          hide-ellipsis
          :total-rows="totalRow"
          :per-page="getPageSize"
          v-model="currentPage"
          @input="changedPage($event)")
      .col-2.mb-1
        b-input-group(:prepend="$t('ui.page_size')" size="sm")
          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
      .col-12(style="max-height: 70vh; overflow: hidden;")
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th.text-center(width="8%")
                  span #
                th(width="18%" @click="sortOrder('transfer_date', 'report')")
                  span(:title="$t('ui.transfer_date')") {{ $t('ui.transfer_date') }}
                  .float-right
                    i(:class="changeSortKey('transfer_date', 'report')")
                th(width="38%")
                  span(:title="$t('ui.detail')") {{ $t('ui.detail') }}
                th.text-right(width="18%")
                  span(:title="$t('ui.credit')") {{ $t('ui.credit') }}
                th.text-right(width="18%")
                  span(:title="$t('ui.debit')") {{ $t('ui.debit') }}
            tbody.clusterize-content
              tr(v-if="statementList.length == 0")
                td(:colspan="5").text-center
                  span {{ $t('message.no_data_available') }}
              tr(v-for="(item, index) in statementList")
                td.text-center
                  span {{ ((currentPage - 1) * getPageSize + index + 1) }}
                td
                  span(:title="$moment(item.transfer_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.transfer_date).format('YYYY-MM-DD, HH:mm:ss') }}
                td
                  span.font-weight-bold {{ item.transfer_type }}

                  span.d-block(v-if="item.transfer_type == 'TRANSFER' && item.transfer_method") {{ item.transfer_method }}
                  span.d-block(v-if="(item.transfer_type == 'TRANSFER' && item.bank_id)") {{ item.bank_id }}
                  span.d-block(v-if="(item.transfer_type == 'TRANSFER' && item.bank_acc_no)") {{ item.bank_acc_no }}
                  span.d-block(v-if="(item.transfer_type == 'TRANSFER' && item.bank_acc_holder)") {{ item.bank_acc_holder }}

                  span.d-block(v-if="item.transfer_type == 'DEPOSIT' && item.transfer_method") {{ item.transfer_method }}
                  span.d-block(v-if="item.transfer_type == 'DEPOSIT' && item.account_id") {{ item.account_id }}

                  span.d-block(v-if="item.transfer_type == 'WITHDRAWAL' && item.transfer_method") {{ item.transfer_method }}
                  span.d-block(v-if="item.transfer_type == 'WITHDRAWAL' && item.account_id") {{ item.account_id }}

                  span.d-block.text-italic(v-if="item.ref_no") {{ item.ref_no }}
                  span.d-block.text-italic(v-if="item.remark") {{ item.remark }}
                td.text-right
                  span.font-weight-bold(:title="$n(item.credit_amount, 'currency')") {{ $n(item.credit_amount, 'currency') }}
                td.text-right
                  span.font-weight-bold.text-danger(:title="$n(item.debit_amount, 'currency')") {{ $n(item.debit_amount, 'currency') }}
              tr(v-if="showTotal")
                td.text-right(colspan="3")
                  span {{ $t("ui.sub_total") }}
                  span.d-block {{ $t("ui.grand_total") }}
                td
                  span.font-weight-bold.text-right.d-block(:class="$helpers.fontClassName(subTotalCreditAmount)" :title="$n(subTotalCreditAmount, 'currency')") {{ $n(subTotalCreditAmount, 'currency') }}
                  span.font-weight-bold.text-right.d-block(:class="$helpers.fontClassName(grandTotalCreditAmount)" :title="$n(grandTotalCreditAmount, 'currency')") {{ $n(grandTotalCreditAmount, 'currency') }}
                td
                  span.font-weight-bold.text-right.d-block(:class="$helpers.fontClassName(subTotalDebitAmount)" :title="$n(subTotalDebitAmount, 'currency')") {{ $n(subTotalDebitAmount, 'currency') }}
                  span.font-weight-bold.text-right.d-block(:class="$helpers.fontClassName(grandTotalDebitAmount)" :title="$n(grandTotalDebitAmount, 'currency')") {{ $n(grandTotalDebitAmount, 'currency') }}

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import BankAccountList from "@/library/BankAccountList";
import jsonToExcel from "@/library/jsonToExcelFull.vue";
import jsonToExcelFull from "@/library/jsonToExcelFull.vue";
import bankStatementExport from "@/components/bank/bankStatementExportFull.vue";
import bankStatementExportFull from "@/components/bank/bankStatementExportFull.vue";

export default {
  components: {
    SubmitButton,
    BankAccountList,
    jsonToExcel,
    jsonToExcelFull,
    bankStatementExport,
    bankStatementExportFull
  },
  data: () => ({
    loading2: false,
    loading: false,
    statementListFull: [],
    statementList: [],
    currentPage: 1,
    totalRow: 0,
    search: "",
    subTotalDebitAmount: 0,
    grandTotalDebitAmount: 0,
    subTotalCreditAmount: 0,
    grandTotalCreditAmount: 0,
    showTotal: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    startDate: null,
    endDate: null,
    bank: '',
    monthOpt: [],
    selectedMonth: null,
    currentBank: null,
    sortKey: "transfer_date",
    sortType: "desc",
    dateRange: {
      startDate: null,
      endDate: null
    },
    grandTotalList: [],
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSizeBank;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    }
  },
  methods: {
    refresh() {
      this.getDateOpt();
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
      this.getBankStatement(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    getListing() {
      this.getBankStatement(true);
      this.getBankStatementFull(true);
    },
    getDateOpt() {
      for(var i = 0; i > -3; i--) {
        this.monthOpt.push(this.$moment(new Date).add(i, 'month').format('YYYY-MM'));
      }

      this.selectedMonth = this.$moment(new Date).format('YYYY-MM');
    },
    getBankStatement: function(isSearch) {
      this.currentBank = this.bank;

      let url = config.bankStatementUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        bank_id: this.bank == '' ? null : this.bank.split(' - ')[0].trim(),
        bank_acc_no: this.bank == '' ? null : this.bank.split(' - ')[1].trim(),
        working_month: this.$moment(this.selectedMonth).startOf("month").format("YYYY-MM-DD"),
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.clearTotal()
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.dateRange.startDate = this.$moment(this.selectedMonth).startOf("month").format("YYYY-MM-DD");
                this.dateRange.endDate = this.$moment(this.selectedMonth).endOf("month").format("YYYY-MM-DD");

                if(response.data.ds.statement != null && response.data.ds.statement.length > 0) {
                  this.showTotal = true;
                  response.data.ds.statement.forEach(value => {
                    this.subTotalDebitAmount = parseFloat(this.subTotalDebitAmount) + parseFloat(value["debit_amount"]);
                    this.subTotalCreditAmount = parseFloat(this.subTotalCreditAmount) + parseFloat(value["credit_amount"]);
                  });

                  if(response.data.ds.grand_total.length > 0) {
                    this.grandTotalDebitAmount = response.data.ds.grand_total[0]["debit_amount"];
                    this.grandTotalCreditAmount = response.data.ds.grand_total[0]["credit_amount"];
                  }

                  this.grandTotalList = response.data.ds.grand_total

                  this.statementList = response.data.ds.statement;
                  this.totalRow = response.data.ds.statement.length > 0 ? this.statementList[0]["totalrows"] : 0
                } else {
                  this.clearTotal()
                }
              } else {
                this.clearTotal()
                if (this.feedback.status != 'permission_denied') {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
                else {
                  this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getBankStatementFull: function(isSearch) {
      let url = config.bankStatementUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        bank_id: this.bank == '' ? null : this.bank.split(' - ')[0].trim(),
        bank_acc_no: this.bank == '' ? null : this.bank.split(' - ')[1].trim(),
        working_month: this.$moment(this.selectedMonth).startOf("month").format("YYYY-MM-DD"),
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: -1
      };

      this.loading2 = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading2 = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.statementListFull = response.data.ds.statement;
              } else {
                if (this.feedback.status != 'permission_denied') {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
                else {
                  this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading2 = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    clearTotal() {
      this.showTotal = false
      this.statementList = []
      this.totalRow = 0
      this.subTotalDebitAmount = 0
      this.grandTotalDebitAmount = 0
      this.subTotalCreditAmount = 0
      this.grandTotalCreditAmount = 0
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSizeBank", pageSize);
      this.currentPage = 1;
      this.getBankStatement(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getBankStatement();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
.text-italic {
  font-style: italic !important;
}
</style>